<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>卡组集齐数量人数</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="选择活动" prop="id">
        <el-select
          v-model="queryParams.id"
          clearable
          style="width: 380px;"
          placeholder="请选择"
          filterable
          @change="idChange"
          @visible-change="handleVisibleChange"
        >
          <el-option
            v-for="item in actArr"
            :key="item.value"
            :label="getActOptionLabel(item)"
            :value="item.value"
          />
          <el-option
            v-if="hasMoreAct"
            value=""
            disabled
            style="text-align: center; cursor: pointer;"
          >
            <span v-if="actLoading" style="color: #999;">加载中...</span>
            <span v-else style="color: #409EFF;" @click.stop="loadMoreAct">点击加载更多</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          :disabled="dateDisabled"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          :disabled="dateDisabled"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery(false)">查询</el-button>
        <el-button icon="el-icon-download" size="mini" :loading="loading" @click="handleQuery(true)">导出</el-button>
      </el-form-item>
    </el-form>

    <template>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="集齐卡组数"
          align="center"
        />
        <el-table-column
          v-for="(item, index) in cardGroupCount"
          :key="index"
          align="center"
          :label="'集齐'+item+'组'"
        >
          <template slot-scope="{row}">
            <span v-if="row.data[item]">{{ row.data[item] }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>

      </el-table>
    </template>
    <echartTemp ref="group" title="卡组集齐数量人数" />
  </el-card>
</template>
<script >
import { getCardGroupSumStat } from '@/api/config/card-stat'
import echartTemp from '@/components/Charts/Charts.vue'
import actList from '../mixins/actList.js'
import { getLastDates } from '@/utils/index.js'

export default {
  components: {
    echartTemp
  },
  mixins: [actList],
  props: {
    selectedActId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      tableData: [],
      loading: false,
      dateDisabled: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 0,
        startString: '',
        endString: '',
        id: ''
      },
      cardGroupCount: 0
    }
  },
  watch: {
    selectedActId: {
      immediate: true,
      handler(val) {
        if (val !== undefined && val !== '') {
          this.syncActChange(val)
        }
      }
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
  },
  mounted() {
    this.loadActList()
  },
  methods: {
    getTables() {
      this.loading = true
      getCardGroupSumStat(this.queryParams).then(res => {
        this.loading = false
        if (this.queryParams.type > 0) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
        }
        const { data, count } = res.data
        this.cardGroupCount = count
        this.tableData = data
        this.refreshChart()
      })
    },
    handleQuery(isExport) {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.queryParams.type = 0
      if (isExport) {
        this.queryParams.type = 1
      }
      this.getTables()
    },
    refreshChart() {
      const summaryRow = this.tableData.find(row => row.date === '汇总')
      const xAxis = []
      const data = []
      for (let i = 1; i <= this.cardGroupCount; i++) {
        xAxis.push(`集齐${i}组`)
        const val = summaryRow ? summaryRow.data[i] : 0
        data.push(val || 0)
      }

      const series = [{
        name: '汇总',
        data: data,
        type: 'line',
        smooth: true,
        label: {
          show: true,
          position: 'top',
          formatter: '{c}'
        }
      }]

      const obj = { legend: ['汇总'], series: series, xAxis: xAxis }
      this.$refs.group.refresh(obj)
    },
    idChange(event) {
      this.queryParams.startString = ''
      this.queryParams.endString = ''
      if (event !== '') {
        const dateRange = this.dateRange[event]
        const dateArr = dateRange.split('至')
        this.queryParams.startString = dateArr[0]
        this.queryParams.endString = dateArr[1]
      }
      this.dateDisabled = event !== ''
    },
    getActOptionLabel(item) {
      const actName = this.actNameMap[item.value] || ''
      const dateRange = this.dateRange[item.value] || item.label
      return actName ? `${actName} - ${dateRange}` : dateRange
    },
    syncActChange(actId) {
      this.queryParams.id = actId
      this.idChange(actId)
    }
  }
}
</script>
<style scoped>

</style>
